import styled, { keyframes } from "styled-components";

const drift1 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(50px, -40px) scale(1.12); }
`;
const drift2 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-60px, 40px) scale(1.15); }
`;
const drift3 = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(30px, 60px) scale(0.92); }
`;

export const Wrap = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
`;

const Orb = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
  }
`;

export const OrbOne = styled(Orb)`
  width: 34vw;
  height: 34vw;
  min-width: 320px;
  min-height: 320px;
  max-width: 560px;
  max-height: 560px;
  background: #8b7cff;
  opacity: 0.35;
  top: -12%;
  left: -10%;
  animation: ${drift1} 15s ease-in-out infinite;
`;

export const OrbTwo = styled(Orb)`
  width: 30vw;
  height: 30vw;
  min-width: 280px;
  min-height: 280px;
  max-width: 480px;
  max-height: 480px;
  background: #22d3ee;
  opacity: 0.28;
  bottom: -16%;
  right: -8%;
  animation: ${drift2} 17s ease-in-out infinite;
`;

export const OrbThree = styled(Orb)`
  width: 20vw;
  height: 20vw;
  min-width: 200px;
  min-height: 200px;
  max-width: 340px;
  max-height: 340px;
  background: #c084fc;
  opacity: 0.2;
  top: 32%;
  right: 22%;
  animation: ${drift3} 19s ease-in-out infinite;
`;

export const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(ellipse at 50% 20%, black 10%, transparent 68%);
  -webkit-mask-image: radial-gradient(ellipse at 50% 20%, black 10%, transparent 68%);
`;
